
export default {
  name: 'SocialPicto',

  props: {
    name: { type: String, default: '' },
  },

  computed: {
    nameSafe() {
      return this.name.toLowerCase()
    },
  },
}
